// extracted by mini-css-extract-plugin
export default {"wrapper":"Box_wrapper__fa1R0","image":"Box_image__EHsLn","content":"Box_content__NFCkr","title":"Box_title__ljD6W","icon":"Box_icon__nkM-n","text":"Box_text__rvFaR"};